import { subscriptionService } from '../services/subscription.service';

const state = {
  all: {}
};

const actions = {
  async getAll({ dispatch, commit }) {
    try {
      const subscriptions = await subscriptionService.getSubscriptions();
      commit('getSubscriptionsSuccess', subscriptions);
    }
    catch (error) {
      throw error;
    }
  }
};

const mutations = {
  getSubscriptionsSuccess(state, subscriptions) {
    state.all = subscriptions;
  }
};

export const subscriptions = {
  namespaced: true,
  state,
  actions,
  mutations
};
